import {isNullOrUndefined} from "../../../../services/Validator";
import ExerciserResultsScoreCard from "../../../cards/courses/exercisers/ExerciserResultsScoreCard";
import ExerciserResultsGraphCard from "../../../cards/courses/exercisers/ExerciserResultsGraphCard";

export default function ExerciserResultsTabletSummary({scores, total}) {
    // Used in FlashResultsScreen to display flash score summary
    // in tablet mode

    // BUILD
    if (isNullOrUndefined(scores) && isNullOrUndefined(total))
        return null;
    return (
        <div className={"w-full hidden sm:flex lg:hidden space-x-24 mt-24"}>
            <ExerciserResultsScoreCard scores={scores}
                                       total={total} />
            <ExerciserResultsGraphCard scores={scores} />
        </div>
    );
}